<template>
  <div class="sign-setting">
    <div class="title">基本信息</div>
    <Form class="form" :model="form">
      <FormItem label="日签奖励：">
        <InputNumber :min="0" v-model="form.daily_award"></InputNumber>
        <span class="tag">积分</span>
      </FormItem>
      <FormItem label="连续签到：">
        <span style="color:#999;">签到周期以最大连签天数为准</span>
      </FormItem>
      <FormItem class="sign-rule-wrap">
        <Table :columns="columns" :data="form.rules" :width="1000">
          <template slot="action" slot-scope="{ row, index }">
            <Button
              type="text"
              size="small"
              @click="onAddRule('edit', row, index)"
              >编辑</Button
            >
            <span>-</span>
            <Button type="text" size="small" @click="onRemoveRule(index)"
              >删除</Button
            >
          </template>
        </Table>
        <Button
          class="btn"
          icon="ios-add"
          type="primary"
          @click="onAddRule('add')"
          >添加规则</Button
        >
      </FormItem>
    </Form>
    <div class="title">其他设置</div>
    <Form class="form" :model="form">
      <FormItem label="页面名称：">
        <Input
          class="input-style"
          v-model="form.page_title"
          placeholder="请输入页面名称，最多可添加28个字"
          :maxlength="28"
        ></Input>
        <CharCount :max="28" :text="form.page_title"></CharCount>
      </FormItem>
      <FormItem label="页面描述：">
        <Input
          class="input-style"
          v-model="form.page_desc"
          placeholder="通过链接分享给好友时，显示该内容"
          :maxlength="38"
        ></Input>
        <CharCount :max="38" :text="form.page_desc"></CharCount>
      </FormItem>
      <FormItem label="签到规则：">
        <UEditor v-model="form.point_sign_rule_info" toolbar="simple"></UEditor>
      </FormItem>
    </Form>
    <Divider />
    <div class="submit-wrap">
      <Button type="primary" @click="onSave" size="large" style="width:100px;"
        >保存</Button
      >
    </div>
    <Modal v-model="modalAdd.show" :title="modalAdd.title">
      <Form :model="modalAdd.form" :label-width="90">
        <FormItem label="签到天数：">
          <InputNumber
            :min="1"
            v-model="modalAdd.form.sign_day"
            :precision="0"
          ></InputNumber>
          <span class="tag">天</span>
        </FormItem>
        <FormItem label="连签奖励：">
          <InputNumber
            :min="1"
            v-model="modalAdd.form.point"
            :precision="0"
          ></InputNumber>
          <span class="tag">分</span>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align:center;">
        <Button @click="modalAdd.show = false">取消</Button>
        <Button type="primary" @click="onOkAdd">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import UEditor from "@/components/UEditor";
export default {
  name: "sign-setting",
  components: {
    UEditor
  },
  data() {
    return {
      form: {
        daily_award: 0,
        page_title: "",
        page_desc: "",
        point_sign_rule_info: "",
        rules: []
      },
      columns: [
        { title: "签到天数", key: "sign_day", align: "center" },
        { title: "连签奖励", key: "point", align: "center" },
        { title: "操作", slot: "action", align: "center" }
      ],
      modalAdd: {
        show: false,
        title: "",
        type: "add", // add 或 edit
        editIndex: 0, // 编辑模式下的行索引
        form: {
          sign_day: 1,
          point: 1
        }
      }
    };
  },
  created() {
    this.requestData();
  },
  methods: {
    // on event
    onAddRule(type, row, index) {
      this.modalAdd.show = true;
      this.modalAdd.type = type;
      if (type == "add") {
        this.modalAdd.title = "新增规则";
        this.$pub.clearObj(this.modalAdd.form, [], 1);
      } else {
        this.modalAdd.title = "编辑规则";
        this.modalAdd.editIndex = index;
        this.modalAdd.form.sign_day = row.sign_day;
        this.modalAdd.form.point = row.point;
      }
    },
    async onRemoveRule(index) {
      await this.$promiseConfirm(
        "删除后，有可能会影响签到周期以及连签奖励，是否确认？"
      );
      this.form.rules.splice(index, 1);
    },
    onOkAdd() {
      if (this.modalAdd.type == "add") {
        // 检测是否存在相同的“签到天数”
        const result = this.form.rules.filter(i => {
          return i.sign_day == this.modalAdd.form.sign_day;
        });
        if (result.length) {
          this.$Message.info("签到天数已存在，请重新编辑");
          return;
        }
        // 开始插入
        this.form.rules.push(Object.assign({}, this.modalAdd.form));
        this.modalAdd.show = false;
      } else {
        const row = this.form.rules[this.modalAdd.editIndex];
        row.sign_day = this.modalAdd.form.sign_day;
        row.point = this.modalAdd.form.point;
        this.modalAdd.show = false;
      }
      this.$Message.success("操作成功");
    },
    onSave() {
      const formCopy = Object.assign({}, this.form);
      formCopy.rules = JSON.stringify(formCopy.rules);
      this.$http.post("/api/integral/sign/setting", formCopy).then(() => {
        this.$Message.success("保存成功");
      });
    },
    // request
    requestData() {
      this.$http.get("/api/integral/sign/setting").then(data => {
        data.daily_award = +data.daily_award;
        this.form = data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sign-setting {
  .form {
    padding: 0 20px;
  }
  .input-style {
    width: 300px;
    margin-right: 5px;
  }
  .sign-rule-wrap {
    position: relative;
    .btn {
      position: absolute;
      top: -45px;
      left: 900px;
    }
  }
  .submit-wrap {
    text-align: center;
  }
  .ueditor {
    display: inline-block;
    max-width: 1000px;
  }
}
.tag {
  margin-left: 10px;
}
</style>
